module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page wallet rule"
  }, [_c('pageTitle', {
    attrs: {
      "title": "会员储值优惠政策及使用规则"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', [_c('strong', [_vm._v("储值优惠政策")])]), _vm._v(" "), _c('div', [_vm._v("\n      2017年12月25日-2018年12月25日期间，充1000元送1000K币+100元电子代金券（5张面额20元）。\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', [_c('strong', [_vm._v("如何充值")])]), _vm._v(" "), _c('div', [_vm._v("\n      登陆官网、APP或官方微信，进入会员中心“我的储值”页面充值，也可在酒店扫描二维码进行充值。\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', [_c('strong', [_vm._v("关于发票")])]), _vm._v(" "), _c('div', [_vm._v("\n      每次消费离店时，由酒店前台现场开发票。\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', [_c('strong', [_vm._v("储值如何使用")])]), _vm._v(" "), _c('div', [_vm._v("\n      （1） 会员储值可用于官网、APP、官方微信预订支付，以及商城购物。"), _c('br'), _vm._v("\n      （2） 会员储值不能提现，不能退款。 \n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ea0910a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wallet/valueCardRule.vue
// module id = 1439
// module chunks = 18